import { render, staticRenderFns } from "./BigReverse.vue?vue&type=template&id=9b1d55c6&scoped=true&"
import script from "./BigReverse.vue?vue&type=script&lang=js&"
export * from "./BigReverse.vue?vue&type=script&lang=js&"
import style0 from "./BigReverse.vue?vue&type=style&index=0&id=9b1d55c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1d55c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b1d55c6')) {
      api.createRecord('9b1d55c6', component.options)
    } else {
      api.reload('9b1d55c6', component.options)
    }
    module.hot.accept("./BigReverse.vue?vue&type=template&id=9b1d55c6&scoped=true&", function () {
      api.rerender('9b1d55c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MarketingActivityEdit/ActivePages/BigReverse.vue"
export default component.exports